/** 平台「模拟登录」：本地暂存操作者会话，退出时还原；对方无登录痕迹。 */

const ACTOR_SESSION_KEY = "c456.impersonator_session";
const IMPERSONATION_META_KEY = "c456.impersonation_meta";
const CURRENT_ACCOUNT_KEY = "c456.current_account_id";

export type StashedActorSession = {
  access_token: string;
  refresh_token: string;
  expires_at: string | null;
};

export type ImpersonationMeta = {
  actor_user_id: number;
  actor_label: string;
  target_user_id: number;
  target_label: string;
};

export function stashActorSession(session: StashedActorSession) {
  sessionStorage.setItem(ACTOR_SESSION_KEY, JSON.stringify(session));
}

export function readStashedActorSession(): StashedActorSession | null {
  const raw = sessionStorage.getItem(ACTOR_SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StashedActorSession;
    if (!parsed.access_token || !parsed.refresh_token) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearStashedActorSession() {
  sessionStorage.removeItem(ACTOR_SESSION_KEY);
}

export function writeImpersonationMeta(meta: ImpersonationMeta) {
  sessionStorage.setItem(IMPERSONATION_META_KEY, JSON.stringify(meta));
}

export function readImpersonationMeta(): ImpersonationMeta | null {
  const raw = sessionStorage.getItem(IMPERSONATION_META_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImpersonationMeta;
  } catch {
    return null;
  }
}

export function clearImpersonationMeta() {
  sessionStorage.removeItem(IMPERSONATION_META_KEY);
}

/** 切换身份时清掉工作账户记忆，避免串到原账号上下文 */
export function clearRememberedAccountId() {
  localStorage.removeItem(CURRENT_ACCOUNT_KEY);
}
